// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/approval_flow_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalMode, ApprovalStrategy, BusinessProcess, PlanningSection, SwitchReason, WorkflowSchedule } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/approval_flow_model.proto.
 */
export const file_bffuser_v1_approval_flow_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_approval_flow_type, file_bfftypes_v1_area, file_bfftypes_v1_side, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_decimal]);

/**
 * ApprovalFlowProcessSetting holds the complete approval flow configuration
 * for one business process. Mirrors backend internalapi.v1.ApprovalFlowProcessSetting;
 * organization_id is absent (resolved from eauth session by BFF).
 *
 * @generated from message bffuser.v1.ApprovalFlowProcessSetting
 */
export type ApprovalFlowProcessSetting = Message<"bffuser.v1.ApprovalFlowProcessSetting"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowCell cells = 2;
   */
  cells: ApprovalFlowCell[];

  /**
   * @generated from field: repeated bffuser.v1.AutoSwitchCondition conditions = 3;
   */
  conditions: AutoSwitchCondition[];

  /**
   * updated_at is used as the expected_updated_at baseline when saving.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * auto_bid_rules lists the 自動入札ルール (設定層) configured for the
   * 自動 (AUTO) approval-mode areas of this business process.
   *
   * @generated from field: repeated bffuser.v1.AutoBidRule auto_bid_rules = 5;
   */
  autoBidRules: AutoBidRule[];

  /**
   * auto_bid_rules_basis_unselected lists the sides whose saved rule is opened
   * with its 基準 unselected (AC-APF-076). Such a side counts as not saved, so
   * it never appears in auto_bid_rules; a (area_code, bid_side) is in at most
   * one of the two.
   *
   * @generated from field: repeated bffuser.v1.AutoBidRuleBasisUnselected auto_bid_rules_basis_unselected = 6;
   */
  autoBidRulesBasisUnselected: AutoBidRuleBasisUnselected[];
};

/**
 * Describes the message bffuser.v1.ApprovalFlowProcessSetting.
 * Use `create(ApprovalFlowProcessSettingSchema)` to create a new message.
 */
export const ApprovalFlowProcessSettingSchema: GenMessage<ApprovalFlowProcessSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 0);

/**
 * SpotBidConfig mirrors backend internalapi.v1.SpotBidConfig.
 *
 * @generated from message bffuser.v1.SpotBidConfig
 */
export type SpotBidConfig = Message<"bffuser.v1.SpotBidConfig"> & {
  /**
   * @generated from field: bffuser.v1.AutoBidOrderMethod order_method = 1;
   */
  orderMethod: AutoBidOrderMethod;

  /**
   * limit_price_yen_per_kwh is present only when order_method =
   * AUTO_BID_ORDER_METHOD_LIMIT (0.01-999 円/kWh).
   *
   * @generated from field: optional google.type.Decimal limit_price_yen_per_kwh = 2;
   */
  limitPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.SpotBidConfig.
 * Use `create(SpotBidConfigSchema)` to create a new message.
 */
export const SpotBidConfigSchema: GenMessage<SpotBidConfig> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 1);

/**
 * IntradayBidConfig mirrors backend internalapi.v1.IntradayBidConfig.
 *
 * @generated from message bffuser.v1.IntradayBidConfig
 */
export type IntradayBidConfig = Message<"bffuser.v1.IntradayBidConfig"> & {
  /**
   * @generated from field: bffuser.v1.IntradayPriceMode price_mode = 1;
   */
  priceMode: IntradayPriceMode;

  /**
   * basis is present only when price_mode = INTRADAY_PRICE_MODE_DETERMINE.
   *
   * @generated from field: optional bffuser.v1.IntradayBasis basis = 2;
   */
  basis?: IntradayBasis;

  /**
   * fixed_price_yen_per_kwh is present only when basis =
   * INTRADAY_BASIS_FIXED (0.01-999 円/kWh).
   *
   * @generated from field: optional google.type.Decimal fixed_price_yen_per_kwh = 3;
   */
  fixedPriceYenPerKwh?: Decimal;

  /**
   * adjustment_yen_per_kwh (手数料等) is always required (-999-999 円/kWh).
   *
   * @generated from field: google.type.Decimal adjustment_yen_per_kwh = 4;
   */
  adjustmentYenPerKwh?: Decimal;

  /**
   * counter_ref_price_yen_per_kwh / bid_price_yen_per_kwh are present only
   * when price_mode = INTRADAY_PRICE_MODE_SNAP_UP (0.01-999 円/kWh each).
   *
   * @generated from field: optional google.type.Decimal counter_ref_price_yen_per_kwh = 5;
   */
  counterRefPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal bid_price_yen_per_kwh = 6;
   */
  bidPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.IntradayBidConfig.
 * Use `create(IntradayBidConfigSchema)` to create a new message.
 */
export const IntradayBidConfigSchema: GenMessage<IntradayBidConfig> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 2);

/**
 * AutoBidRule mirrors backend internalapi.v1.AutoBidRule;
 * organization_id is absent (resolved from eauth session by BFF).
 * process_config carries the process-specific fields (former flat fields
 * 4/5 — order_method / limit_price_yen_per_kwh — moved into SpotBidConfig).
 *
 * @generated from message bffuser.v1.AutoBidRule
 */
export type AutoBidRule = Message<"bffuser.v1.AutoBidRule"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side bid_side = 2;
   */
  bidSide: Side;

  /**
   * coverage_pct is the coverage ratio (%) applied to the coma-level
   * shortfall/surplus (0-100 integer).
   *
   * @generated from field: int32 coverage_pct = 3;
   */
  coveragePct: number;

  /**
   * @generated from oneof bffuser.v1.AutoBidRule.process_config
   */
  processConfig: {
    /**
     * @generated from field: bffuser.v1.SpotBidConfig spot = 6;
     */
    value: SpotBidConfig;
    case: "spot";
  } | {
    /**
     * @generated from field: bffuser.v1.IntradayBidConfig intraday = 7;
     */
    value: IntradayBidConfig;
    case: "intraday";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.AutoBidRule.
 * Use `create(AutoBidRuleSchema)` to create a new message.
 */
export const AutoBidRuleSchema: GenMessage<AutoBidRule> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 3);

/**
 * AutoBidRuleBasisUnselected mirrors backend internalapi.v1.AutoBidRuleBasisUnselected.
 *
 * @generated from message bffuser.v1.AutoBidRuleBasisUnselected
 */
export type AutoBidRuleBasisUnselected = Message<"bffuser.v1.AutoBidRuleBasisUnselected"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side bid_side = 2;
   */
  bidSide: Side;

  /**
   * coverage_pct is the saved coverage ratio (%) (0-100 integer).
   *
   * @generated from field: int32 coverage_pct = 3;
   */
  coveragePct: number;

  /**
   * adjustment_yen_per_kwh is the saved 基準からの調整 (-999-999 円/kWh).
   *
   * @generated from field: google.type.Decimal adjustment_yen_per_kwh = 4;
   */
  adjustmentYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.AutoBidRuleBasisUnselected.
 * Use `create(AutoBidRuleBasisUnselectedSchema)` to create a new message.
 */
export const AutoBidRuleBasisUnselectedSchema: GenMessage<AutoBidRuleBasisUnselected> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 4);

/**
 * ApprovalFlowCell represents one unit of approval-flow configuration.
 *
 * @generated from message bffuser.v1.ApprovalFlowCell
 */
export type ApprovalFlowCell = Message<"bffuser.v1.ApprovalFlowCell"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * section is optional; absent means the cell applies to all sections.
   *
   * @generated from field: optional bfftypes.v1.PlanningSection section = 2;
   */
  section?: PlanningSection;

  /**
   * schedule is optional; absent means the cell applies to all schedules.
   *
   * @generated from field: optional bfftypes.v1.WorkflowSchedule schedule = 3;
   */
  schedule?: WorkflowSchedule;

  /**
   * approval_mode is required. Cells without a configured mode are omitted
   * from the repeated list rather than being sent as UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.ApprovalMode approval_mode = 4;
   */
  approvalMode: ApprovalMode;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowStage stages = 5;
   */
  stages: ApprovalFlowStage[];
};

/**
 * Describes the message bffuser.v1.ApprovalFlowCell.
 * Use `create(ApprovalFlowCellSchema)` to create a new message.
 */
export const ApprovalFlowCellSchema: GenMessage<ApprovalFlowCell> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 5);

/**
 * ApprovalFlowStage represents a single stage within an approval flow cell.
 *
 * @generated from message bffuser.v1.ApprovalFlowStage
 */
export type ApprovalFlowStage = Message<"bffuser.v1.ApprovalFlowStage"> & {
  /**
   * @generated from field: int32 stage_order = 1;
   */
  stageOrder: number;

  /**
   * @generated from field: bfftypes.v1.ApprovalStrategy strategy = 2;
   */
  strategy: ApprovalStrategy;

  /**
   * @generated from field: repeated string approver_member_ids = 3;
   */
  approverMemberIds: string[];
};

/**
 * Describes the message bffuser.v1.ApprovalFlowStage.
 * Use `create(ApprovalFlowStageSchema)` to create a new message.
 */
export const ApprovalFlowStageSchema: GenMessage<ApprovalFlowStage> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 6);

/**
 * AutoSwitchCondition defines when the system automatically switches
 * approval mode for a given planning section.
 *
 * @generated from message bffuser.v1.AutoSwitchCondition
 */
export type AutoSwitchCondition = Message<"bffuser.v1.AutoSwitchCondition"> & {
  /**
   * @generated from field: bfftypes.v1.PlanningSection section = 1;
   */
  section: PlanningSection;

  /**
   * Range 0-100. Absent means no variance-based switching.
   *
   * @generated from field: optional int32 variance_threshold_percent = 2;
   */
  varianceThresholdPercent?: number;

  /**
   * deadline_minute_of_day triggers a switch when the clock reaches this
   * minute of the day (0-1439, where 0=00:00 and 1439=23:59) without
   * approval. Absent means no deadline-based switching.
   *
   * @generated from field: optional int32 deadline_minute_of_day = 3;
   */
  deadlineMinuteOfDay?: number;
};

/**
 * Describes the message bffuser.v1.AutoSwitchCondition.
 * Use `create(AutoSwitchConditionSchema)` to create a new message.
 */
export const AutoSwitchConditionSchema: GenMessage<AutoSwitchCondition> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 7);

/**
 * SwitchHistoryEntry records a single automatic approval-mode switch event.
 *
 * @generated from message bffuser.v1.SwitchHistoryEntry
 */
export type SwitchHistoryEntry = Message<"bffuser.v1.SwitchHistoryEntry"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * @generated from field: optional bfftypes.v1.PlanningSection section = 2;
   */
  section?: PlanningSection;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.SwitchReason reason = 4;
   */
  reason: SwitchReason;

  /**
   * @generated from field: google.protobuf.Timestamp switched_at = 5;
   */
  switchedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SwitchHistoryEntry.
 * Use `create(SwitchHistoryEntrySchema)` to create a new message.
 */
export const SwitchHistoryEntrySchema: GenMessage<SwitchHistoryEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 8);

/**
 * ApproverCandidate represents a user who can be assigned as an approver.
 *
 * @generated from message bffuser.v1.ApproverCandidate
 */
export type ApproverCandidate = Message<"bffuser.v1.ApproverCandidate"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message bffuser.v1.ApproverCandidate.
 * Use `create(ApproverCandidateSchema)` to create a new message.
 */
export const ApproverCandidateSchema: GenMessage<ApproverCandidate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_model, 9);

/**
 * AutoBidOrderMethod mirrors backend internalapi.v1.AutoBidOrderMethod.
 *
 * @generated from enum bffuser.v1.AutoBidOrderMethod
 */
export enum AutoBidOrderMethod {
  /**
   * @generated from enum value: AUTO_BID_ORDER_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTO_BID_ORDER_METHOD_LIMIT = 1;
   */
  LIMIT = 1,

  /**
   * @generated from enum value: AUTO_BID_ORDER_METHOD_MARKET = 2;
   */
  MARKET = 2,
}

/**
 * Describes the enum bffuser.v1.AutoBidOrderMethod.
 */
export const AutoBidOrderMethodSchema: GenEnum<AutoBidOrderMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_approval_flow_model, 0);

/**
 * IntradayPriceMode mirrors backend internalapi.v1.IntradayPriceMode.
 *
 * @generated from enum bffuser.v1.IntradayPriceMode
 */
export enum IntradayPriceMode {
  /**
   * @generated from enum value: INTRADAY_PRICE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTRADAY_PRICE_MODE_DETERMINE = 1;
   */
  DETERMINE = 1,

  /**
   * @generated from enum value: INTRADAY_PRICE_MODE_SNAP_UP = 2;
   */
  SNAP_UP = 2,
}

/**
 * Describes the enum bffuser.v1.IntradayPriceMode.
 */
export const IntradayPriceModeSchema: GenEnum<IntradayPriceMode> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_approval_flow_model, 1);

/**
 * IntradayBasis mirrors backend internalapi.v1.IntradayBasis.
 *
 * @generated from enum bffuser.v1.IntradayBasis
 */
export enum IntradayBasis {
  /**
   * @generated from enum value: INTRADAY_BASIS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTRADAY_BASIS_BEST_QUOTE = 1;
   */
  BEST_QUOTE = 1,

  /**
   * @generated from enum value: INTRADAY_BASIS_LATEST_TRADE = 2;
   */
  LATEST_TRADE = 2,

  /**
   * @generated from enum value: INTRADAY_BASIS_FIXED = 4;
   */
  FIXED = 4,
}

/**
 * Describes the enum bffuser.v1.IntradayBasis.
 */
export const IntradayBasisSchema: GenEnum<IntradayBasis> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_approval_flow_model, 2);

